import { assertNotEmpty, dateUtils, type Optional } from '@festina-life/core'
import { useLocalStorage } from '@festina-life/ui/hooks'
import dayjs from 'dayjs'
import { type ReactNode, useMemo, useState } from 'react'

import { Provider } from './configurationContext'

type Props = {
  children: ReactNode
}

const ConfigurationProvider = ({ children }: Props) => {
  const [viewAt, saveDate] = useLocalStorage<string>('viewDate')
  const defaultViewAt =
    viewAt ?? dateUtils.dateAsServerStr(dayjs().local().toDate())
  assertNotEmpty(defaultViewAt)
  const [activeFPlusEditorId, setActiveFPlusEditorId] =
    useState<Optional<string>>()
  const [isSearchActive, setIsSearchActive] = useState(true)

  const handleViewAtChanged = (nextDate: Date) => {
    saveDate(dateUtils.dateAsServerStr(nextDate))
  }

  const viewAtDate = useMemo(
    () => dateUtils.dateUtcAsLocal(defaultViewAt).toDate(),
    [defaultViewAt],
  )

  return (
    <Provider
      value={{
        viewAt: viewAtDate,
        viewAtString: defaultViewAt,
        onViewAtChanged: handleViewAtChanged,
        activeFPlusEditorId,
        setActiveFPlusEditorId,
        isSearchActive,
        onChangeSearchActive: setIsSearchActive,
      }}
    >
      {children}
    </Provider>
  )
}

export { ConfigurationProvider }
